export function cacheKey(key: string) {
  return `next:${key}`
}
